import { PaginationButton as SwanPaginationButton } from '@vp/swan'

import { usePaginationLink } from '~/app/features/Gallery/hooks/usePaginationLink'
import { ComponentProps } from 'react'

export interface PropTypes extends ComponentProps<typeof SwanPaginationButton> {
  pageNumber: number
}

export const PaginationButton = (props: PropTypes) => {
  const { disabled, onClick, pageNumber, ...rest } = props

  const linkHref = usePaginationLink(pageNumber)

  return <SwanPaginationButton {...rest} disabled={disabled} href={linkHref} onClick={disabled ? undefined : onClick} />
}

PaginationButton.displayName = 'PaginationButton'
